import { BheliLoader } from "../ui/brand";

/** Carga canónica de la biblioteca, compartida mientras llega el código y durante la consulta. */
export function Waiting({ label }: { label: string }) {
  return (
    <div className="reply-wait">
      <p className="reply-wait-status">
        <BheliLoader size={24} label={label} />
        <span aria-hidden="true">{label}</span>
      </p>
      <div className="reply-skeleton" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((row) => (
          <div key={row}><span></span><span></span><span></span></div>
        ))}
      </div>
    </div>
  );
}
